import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Fine } from '../../entity';
import Enums from '../../utils/enums';
import { FinesService } from '../../service/main/fines.service';
import { ToastrService } from '../../service/common/toastr.service';
import { MenuItem } from 'primeng/api';
import { FineResponse } from '../../entity/fine-response';
import { Console } from '@angular/core/src/console';

declare var jsPDF: any;

@Component({
	selector: 'app-fine-details',
	templateUrl: './fine-details.component.html'
})
export class FineDetailsComponent implements OnInit {
	fine: Fine;
	fineResponse: FineResponse = new FineResponse();
	editableFine: Fine = null;
	selectedImage = '';
	markItems: MenuItem[];

	constructor(
		private route: ActivatedRoute,
		private finesService: FinesService,
		private toastrService: ToastrService
	) { }

	ngOnInit() {
		this.refresh();

		this.markItems = [
			{
				label: 'Verificat', command: () => {
					this.setFineStat(Enums.eFineStat.Processed);
				}
			},
			{
				label: 'Amendat', command: () => {
					this.setFineStat(Enums.eFineStat.Fined);
				}
			},
			{
				label: 'Anulat', command: () => {
					this.setFineStat(Enums.eFineStat.Cancelled);
				}
			},
			{
				label: 'Neverificat', command: () => {
					this.setFineStat(Enums.eFineStat.Issued);
				}
			}
		];
	}

	refresh() {
		const fine = new Fine();
		fine.fromObject(this.route.snapshot.data['fine']);

		fine.FineStat = this.getFineStatByID(fine.FineStatID);

		this.fine = fine;
	}

	editFine(): void {
		this.editableFine = { ...this.fine };
	}

	cancelEdit(): void {
		this.editableFine = null;
	}

	saveChanges(): void {
		const { PvNote, Note } = this.editableFine;

		const dto: Fine = {
			...this.fine,
			PvNote,
			Note
		};

		this.finesService.updateFine(dto).subscribe((fine: Fine) => {
			const updatedFine = new Fine();
			updatedFine.fromObject(fine);

			this.fine = { ...updatedFine };
			this.fine.FineStat = this.getFineStatByID(updatedFine.FineStatID);
			this.editableFine = null;
			this.toastrService.success('Amenda a fost editata cu succes');
		}, (err) => {
			this.toastrService.error('A aparut o eroare la editare');
		});
	}

	setFineStat(fineStatID: number): void {
		const { Note, PvNote, FineStatID } = this.fine;

		if (fineStatID === FineStatID) {
			return;
		}

		if (!Note && fineStatID === Enums.eFineStat.Cancelled) {
			this.toastrService.error(`Este nevoie de completarea campului 'Nota' pentru a putea anula o amenda.`);
			return;
		}

		if (!PvNote && fineStatID === Enums.eFineStat.Fined) {
			this.toastrService.error(`Este nevoie de completarea campului 'PV' pentru a putea trece in statusul amendat.`);
			return;
		}

		const dto: Fine = {
			...this.fine,
			FineStatID: fineStatID
		};

		this.finesService.updateFine(dto).subscribe((fine: Fine) => {
			const updatedFine = new Fine();
			updatedFine.fromObject(fine);

			this.fine.FineStatID = updatedFine.FineStatID;
			this.fine.FineStat = this.getFineStatByID(updatedFine.FineStatID);

			this.toastrService.success('Statusul amenzii a fost editat cu succes');
		}, (err) => {
			this.toastrService.error('A aparut o eroare la editarea statusului');
		});

		// this.fine.FineStat = this.getFineStatByID(fineStatID);
	}

	getFineStatByID(fineStatID: number): string {
		switch (fineStatID) {
			case Enums.eFineStat.Issued:
				return 'Neverificata';
			case Enums.eFineStat.Processed:
				return 'Verificata';
			case Enums.eFineStat.Cancelled:
				return 'Anulata';
			case Enums.eFineStat.Fined:
				return 'Amendat';
		}
	}

	getBadgeClass(): string {
		const { FineStatID } = this.fine;

		switch (FineStatID) {
			case Enums.eFineStat.Processed:
				return 'badge-success';
			case Enums.eFineStat.Issued:
				return 'badge-warning';
			case Enums.eFineStat.Cancelled:
				return 'badge-danger';
			case Enums.eFineStat.Fined:
				return 'badge-primary';
		}
	}

	downloadPDF(): void {
		const { AuthorName, VehicleColor, VehicleType, Title, ParkingName, CheckDate, No, Plate, Pictures } = this.fine;
		var doc = new jsPDF('p', 'pt', 'a4');
		doc = doc.setFontSize(10);
		let imageStartingRow = 470;

		// this.finesService.printFine(this.fine.FineID).subscribe(fineResponse => {
		//     this.fineResponse = fineResponse;
		//     console.log(fineResponse.Script);
		//     fineResponse['Script'].replace(/\/?{(([A-Z])|([a-z]))*}/g," ");
		//     doc = doc.text(20, 20, `${fineResponse.Script}`);
		// });
		//     this.fineResponse['Script'].replace(/\/?{(([A-Z])|([a-z]))*}/g," ");
		//     doc = doc.text(20, 20, `${this.fineResponse.Script}`);
		// doc.save(`Instiintare-${this.fine.No}`);


		if (ParkingName.includes("Reghin")) {
			doc.setFontSize(10);

			doc.text(20, 20, 'ROMANIA');
			doc.text(20, 50, 'JUDETUL MURES');
			doc.text(20, 80, 'PRIMARIA MUNICIPIULUI REGHIN');
			doc.text(20, 110, 'SERVICIUL POLITIA LOCALA');
			doc.text(20, 150, 'Operator date cu caracter personal nr. 23128');
			doc.text(20, 170, 'P-ta Petru Maior, nr.41, tel/fax 0265512448')
			doc.text(20, 190, `Data     : ${CheckDate}`);
			doc.text(20, 210, `Numar  : ${No}`);

			doc.text(60, 240, 'INSTIINTARE');
			doc.text(30, 260, `Va informam ca autovehiculul marca ${VehicleType}`);
			doc.text(20, 275, `culoare ${VehicleColor} cu numar de inmatriculare: ${Plate}`);
			doc.text(20, 290, 'a fost depistat ocupand un loc de parcare cu plata din');
			doc.text(20, 305, `Municipiul Reghin, situat in zona ${ParkingName} , `);
			doc.text(20, 320, 'fara a avea achitat tariful de parcare, incalcand prevederile');
			doc.text(20, 335, `HCL Reghin nr.156/2021 - privind aprobarea ,`);
			doc.text(20, 350, 'Regulamentului de organizare si functionare a sistemului');
			doc.text(20, 365, 'de parcare cu plata din municipiul Reghin, fapt pentru ')
			doc.text(20, 380, 'care ati fost sanctionat contraventional cu amenda de 400 lei.');
			doc.text(30, 395, 'Aveti posibilitatea ca, in termen de 3 zile de la data');
			doc.text(20, 410, 'prezentei, sa achitati 60 lei la casieria Primariei,');
			doc.text(20, 425, 'in caz contrar amenda se va aplica proprietarului autovehiculului(utilizatorului)');
			doc.text(20, 440, 'Sumele se pot achita si online, la www.ghiseul.ro sau www.globalpay.ro');
		} else if (ParkingName.includes("Buzau")) {
			doc.setFontSize(10);

			doc.text(20, 20, 'ROMANIA');
			doc.text(20, 50, 'JUDETUL BUZAU');
			doc.text(20, 80, 'PRIMARIA MUNICIPIULUI BUZAU');
			doc.text(20, 110, 'Strada Spiru Haret nr 6');
			doc.text(20, 140, 'Telefon: 0238.433.870 Fax: 0241/484225');
			doc.text(20, 170, 'P-ta Petru Maior, nr.41, tel/fax 0265512448')
			doc.text(20, 170, `Data     : ${CheckDate}`);
			doc.text(20, 190, `Numar  : ${No}`);

			doc.text(60, 240, 'INSTIINTARE');
			doc.text(30, 260, `Va informam ca autovehiculul marca ${VehicleType}`);
			doc.text(20, 275, `culoare ${VehicleColor} cu numar de inmatriculare: ${Plate}`);
			doc.text(20, 290, 'a fost depistat ocupand un loc de parcare cu plata din');
			doc.text(20, 305, `Municipiul Buzau, situat in zona ${ParkingName} , `);
			doc.text(20, 320, 'fara a avea taxa de parcare achitata. Va instiintam ca');
			doc.text(20, 335, `potrivit HCL Buzau ${Title} taxa de,`);
			doc.text(20, 350, 'parcare se poate achita la parcometru,prin sms la numarul 7442');
			doc.text(20, 365, 'sau cu aplicatia mobila UPPARK, în caz contrar urmând a se aplica')
			doc.text(20, 380, ' o amenda contraventionala de la 200 la 500 lei,precum si');
			doc.text(20, 395, 'sanctiunea complementara de blocare a rotilor autovehiculului');
			doc.text(20, 410, 'Informatii suplimentare puteti obtine la numarul de telefon 0238.433.870.');
		} 
		else if (ParkingName.includes("Calarasi")) {
			doc.setFontSize(10);
			
			doc.text(20, 20, 'ROMANIA');
			doc.text(20, 50, 'JUDETUL CALARASI');
			doc.text(20, 80, 'PRIMARIA MUNICIPIULUI CALARASI');
			doc.text(20, 110, 'Dispecerat Politia Locala: 0756027734 / 0242313525');
			doc.text(20, 140, `Data: ${CheckDate}`);
			doc.text(20, 170, `Numar: ${No}`);

			doc.text(60, 220, 'INSTIINTARE');
			doc.text(20, 235, `Va informam ca autovehiculul marca ${VehicleType}`);
			doc.text(20, 250, `culoarea ${VehicleColor} cu numar de inmatriculare ${Plate}`);
			doc.text(20, 265, 'a fost depistat ocupand un loc de parcare cu plata,');
			doc.text(20, 280, 'din Municipiul Calarasi, fara a avea achitat tariful de');
			doc.text(20, 295, `parcare, incalcand prevederile`);
			doc.text(20, 310, 'HCL 135/2018, fapta pentru care veti fi sanctionat');
			doc.text(20, 325, 'contraventional. La fata locului au fost efectuate planse');
			doc.text(20, 340, 'fotografice care dovedesc aspectele sus mentionate.');
			doc.text(20, 355, 'In termen de 3 zile aveti obligatia sa va prezentati');
			doc.text(20, 370, 'la sediul Politiei Locale Calarasi, din strada Grivita');
			doc.text(20, 385, 'nr.98, pentru luarea masurilor legale.');
		}
		else if (ParkingName.includes("Mangalia")) {
			doc.setFontSize(10);

			doc.text(20, 20, 'ROMANIA');
			doc.text(20, 50, 'JUDETUL CONSTANTA');
			doc.text(20, 80, 'PRIMARIA MUNICIPIULUI MANGALIA');
			doc.text(20, 110, 'DIRECTIA POLITIA LOCALA');
			doc.text(20, 140, 'Operator date cu caracter personal nr.11940');
			doc.text(20, 170, 'STR.PORTULUI NR.82c,tel 0756201224');
			doc.text(20, 190, `Data     : ${CheckDate}`);

			doc.text(60, 220, 'INSTIINTARE');
			doc.text(30, 235, `Va informam ca autovehiculul marca ${VehicleType}`);
			doc.text(20, 250, `culoare ${VehicleColor} cu numar de inmatriculare: ${Plate}`);
			doc.text(20, 265, 'a fost depistat ocupand un loc de parcare cu plata din');
			doc.text(20, 280, `Municipiul Mangalia, situat in ${ParkingName},   fara achitarea, `);
			doc.text(20, 295, 'tarifului de parcare, fiind încalcate prevederile');
			doc.text(20, 310, 'H.C.L. nr.57/2018 privind aprobarea Regulamentului');
			doc.text(20, 325, 'de organizare, functionare si rezervare a parcarilor');
			doc.text(30, 340, 'publice de pe raza Municipiului Mangalia, cu modificarile si');
			doc.text(20, 355, 'completarile ulterioare, fapt pentru  care veti fi sanctionat');
			doc.text(20, 370, 'contraventional cu amenda, stabilita de catre agentul');
			doc.text(20, 385, 'constatator, de la 1.000 la 2.000 lei,conform actului');
			doc.text(30, 400, 'normativ mentionat si cu respectarea prevederilor');
			doc.text(20, 415, 'O.G. nr.2/2001 privind regimul juridic al contraventiilor,cu');
			doc.text(20, 430, 'modificarile si completarile ulterioare.');
			doc.text(20, 445, 'Va rugam ca pe viitor sa achitati tariful de parcare pentru');
			doc.text(30, 460, 'a evita aplicarea sanctiunilor contraventionale.');
			doc.text(20, 475, 'Va multumim pentru intelegere.');
		} else if (ParkingName.includes("Caransebes Oras")) {
			doc.setFontSize(10);

			doc.text(20, 20, 'ROMANIA');
			doc.text(20, 40, 'JUDETUL CARAS-SEVERIN');
			doc.text(20, 60, 'PRIMARIA CARANSEBES');
			doc.text(20, 80, 'SERVICIUL POLITIA LOCALA');
			doc.text(20, 100, 'STR. NICOLAE BALCESCU NR. 117');

			doc.text(20, 160, 'Telefon: 0255 515038')
			doc.text(20, 175, `Data: ${CheckDate}    Numar  : ${No}`);

			doc.text(60, 215, 'INSTIINTARE');
			doc.text(30, 235, `Va informam ca autovehiculul marca ${VehicleType}`);
			doc.text(20, 250, `culoare ${VehicleColor} cu numar de inmatriculare: ${Plate}`);
			doc.text(20, 265, 'a fost depistat ocupand un loc de parcare cu plata');
			doc.text(20, 280, `din Mun. Caransebes, fara a avea achitat`);
			doc.text(20, 295, 'tariful de parcare, incalcand prevederile');
			doc.text(20, 310, `${Title} , fapt pentru care`);
			doc.text(20, 325, 'ati fost sanctionat contraventional.');
			doc.text(20, 340, 'Daca in termen de 2 zile lucratoare nu se achita');
			doc.text(20, 355, 'tariful majorat de 100 lei catre Comaprtimentul Parcari,');
			doc.text(20, 370, 'tariful se va transforma in amenda contraventionala');
			doc.text(20, 385, 'cuprinsa intre 500 - 1000 lei.');
			doc.text(20, 400, 'Utilizatorii pot achita suma de 12 lei prin');
			doc.text(20, 415, 'SMS la 7442. Cod CS7 numar auto sau prin');
			doc.text(20, 430, 'aplicatia UPPARK in ziua emiterii instiintarii');
			doc.text(20, 445, 'sunt exonerati de plata tarifului majorat si a amenzii');
			doc.text(20, 460, 'La fata locului au fost efectuate fotografii care dovedesc ');
			doc.text(20, 475, 'aspectele mai sus mentionate. Sanctiunea contraventionala');
			doc.text(20, 490, 'va fi aplicata proprietarului autovehiculului');

			imageStartingRow = 510;
		} else if (ParkingName.includes("Caransebes")) {
			doc.setFontSize(10);

			doc.text(20, 20, 'ROMANIA');
			doc.text(20, 40, 'JUDETUL CARAS-SEVERIN');
			doc.text(20, 60, 'PRIMARIA CARANSEBES');
			doc.text(20, 80, 'SERVICIUL PUBLIC PIATA GUGULANILOR')
			doc.text(20, 100, 'C.U.I 30122166')
			doc.text(20, 120, 'STR. PIATA LEMNELOR NR.1');

			doc.text(20, 160, 'Telefon: 0255 515038')
			doc.text(20, 175, `Data: ${CheckDate}    Numar  : ${No}`);

			doc.text(60, 215, 'INSTIINTARE');
			doc.text(30, 235, `Va informam ca autovehiculul marca ${VehicleType}`);
			doc.text(20, 250, `culoare ${VehicleColor} cu numar de inmatriculare: ${Plate}`);
			doc.text(20, 265, 'a fost depistat ocupand un loc de parcare cu plata');
			doc.text(20, 280, `din Municipiul Caransebes, fara a avea`);
			doc.text(20, 295, 'achitat tariful de parcare, incalcand prevederile');
			doc.text(20, 310, `${Title} HCL 47 /25.02.2022 , fapt pentru`);
			doc.text(20, 325, 'care ati fost sanctionat contraventional.');
			doc.text(20, 340, 'Daca in termen de 48 de ore nu se achita tariful majorat');
			doc.text(20, 355, 'de 100 RON catre Serviciul Public Piata Gugulanilor,');
			doc.text(20, 370, 'tariful se va transforma in contraventie in valoare de');
			doc.text(20, 385, '300 RON si veti fi sanctionat contraventional de catre');
			doc.text(20, 400, 'Politia Locala Caransebes');
			doc.text(20, 415, 'La fata locului au fost efectuate fotografii care dovedesc ');
			doc.text(20, 430, 'aspectele mai sus mentionate. Sanctiunea contraventionala');
			doc.text(20, 445, 'va fi aplicata proprietarului autovehiculului');
		} else if (ParkingName.includes('Campia Turzii')) {
			doc.setFontSize(10);

			doc.text(20, 20, 'ROMANIA');
			doc.text(20, 30, 'JUDETUL CLUJ');
			doc.text(20, 40, 'PRIMARIA CAMPIA TURZII');
			doc.text(20, 50, 'Serviciul Public Politia Locala')
			doc.text(20, 60, 'Str. Laminoristilor, nr.2')
			doc.text(20, 70, 'Telefon: 0264 991')
			doc.text(20, 80, `Data: ${CheckDate}    Numar: ${No}`);

			doc.text(80, 120, 'INVITATIE');
			doc.text(20, 150, 'IN CALITATE DE CONDUCATOR AUTO AL');
			doc.text(20, 160, 'AUTOTURISMULUI CU NUMAR DE INMATRICULARE:');
			doc.text(20, 170, `${Plate} VA INVITAM LA SEDIUL POLITIEI`);
			doc.text(20, 180, 'LOCALE CAMPIA TURZII IN DATA ...........');
			doc.text(20, 190, 'ORA ........ INTRUCAT ATI');
			doc.text(20, 200, 'PARCAT/OPRIT/STATIONAT NEREGULAMENTAR CONFORM');
			doc.text(20, 210, 'FOTO, INCALCAND PREVEDERILE ART. ...... DIN');
			doc.text(20, 220, '........ IN SITUATIA IN CARE NU VA PREZENTATI');
			doc.text(20, 230, 'VE-TI FI SANCTIONAT CONFORM PREVEDERILOR LEGII');
			doc.text(20, 240, '61/1991 PENTRU NEPREZENTARE SI VOM SOLICITA');
			doc.text(20, 250, 'PROPRIETARULUI DATE CU PRIVIRE LA PERSOANA');
			doc.text(20, 260, 'CARE A FOLOSIT AUTOVEHICULUL URMAND A FI');
			doc.text(20, 270, 'INCHEIAT UN PROCES VERBAL IN LIPSA PENTRU');
			doc.text(20, 280, 'AMBELE FAPTE.');
			doc.text(20, 310, 'AGENT CONSTATATOR ..........................');
			doc.text(20, 320, 'TELEFON: 0264/991');

			imageStartingRow = 340;
		} else if (ParkingName.includes('Carei')) {
			doc.setFontSize(10);

			doc.text(20, 20, 'ROMANIA');
			doc.text(20, 50, 'JUDETUL SATU MARE');
			doc.text(20, 80, 'PRIMARIA MUNICIPIULUI Carei');
			doc.text(20, 145, 'Telefon :0261805045');
			doc.text(20, 160, `Data     : ${CheckDate}`);
			doc.text(20, 175, `Numar  : ${No}`);

			doc.text(60, 190, 'INSTIINTARE');
			doc.text(30, 220, `Va informam ca autovehiculul marca ${VehicleType}`);
			doc.text(20, 235, `culoare ${VehicleColor} cu numar de inmatriculare: ${Plate}`);
			doc.text(20, 250, 'a fost depistat ocupand un loc de parcare cu plata din');
			doc.text(20, 265, `Municipiul Carei, situat in zona ${ParkingName} , `);
			doc.text(20, 280, 'fara a avea achitat tariful de parcare, incalcand prevederile');
			doc.text(20, 295, `${Title}, fapt pentru `);
			doc.text(20, 310, 'care ati fost sanctionat contraventional');
			doc.text(30, 325, 'La fata locului au fost efectuate fotografii care dovedesc ');
			doc.text(20, 340, 'aspectele mai sus mentionate. Sanctiunea contraventionala');
			doc.text(20, 355, 'va fi aplicata proprietarului autovehiculului');
			} 
			else if (ParkingName.includes('Jurilovca')){
			doc.setFontSize(10);
            doc.text(20, 20, 'ROMANIA');
            doc.text(20, 50, 'JUDETUL TULCEA');
            doc.text(20, 80, 'PRIMARIA COMUNEI JURILOVCA');
            doc.text(20, 145, 'Telefon:+40720265579 ');
            doc.text(20, 160, "Data     : " + CheckDate);
            doc.text(20, 175, "Numar  : " + No);
            doc.text(60, 190, 'INSTIINTARE');
            doc.text(30, 220, "Va informam ca autovehiculul marca " + VehicleType);
            doc.text(20, 235, "culoare " + VehicleColor + " cu numar de inmatriculare: " + Plate);
            doc.text(20, 250, 'a fost depistat ocupand un loc de parcare cu plata din Comuna Jurilovca');
            doc.text(20, 265, 'fara a avea achitat tariful de parcare, incalcand prevederile');
            doc.text(20, 280, Title + ", HCL 39 / 29.04.2024, fapt pentru ");
            doc.text(20, 295, 'care ati fost sanctionat contraventional');
            doc.text(30, 310, 'Daca în termen de 48 de ore nu achita?i tariful majorat de 90 RON catre PRIMARIA COMUNEI JURILOVCA');
            doc.text(20, 325, ' – Serviciul Parcari, situata în Jurilovca, Str. 1 Mai nr. 2, jud. Tulcea, ');
            doc.text(20, 340, 'tariful se va transforma în contravenie în valoare de  500 RON si veti fi sanctionat');
			doc.text(20, 355, 'contraventional conform prevederilor legale');
			doc.text(20, 370, 'La fata locului au fost efectuate fotografii care dovedesc aspectele mai sus mentionate');
			doc.text(20, 385, 'Sanctiunea contraventionala va fi aplicata proprietarului autovehiculului');
		}
		else if (ParkingName.includes('Horezu')) {
            doc.setFontSize(10);
            doc.text(20, 20, 'ROMANIA');
            doc.text(20, 50, 'JUDETUL VALCEA');
            doc.text(20, 80, 'PRIMARIA ORASULUI HOREZU');
            doc.text(20, 145, 'Dispecerat Politia Locala :0732079969 / 0742744343');
            doc.text(20, 160, "Data     : " + CheckDate);
            doc.text(20, 175, "Numar  : " + No);
            doc.text(60, 190, 'INSTIINTARE');
            doc.text(30, 220, "Va informam ca autovehiculul marca " + VehicleType);
            doc.text(20, 235, "culoare " + VehicleColor + " cu numar de inmatriculare: " + Plate);
            doc.text(20, 250, 'a fost depistat ocupand un loc de parcare cu plata din');
            doc.text(20, 265, "Orasul Horezu, situat in zona " + ParkingName + " , ");
            doc.text(20, 280, 'fara a avea achitat tariful de parcare, incalcand prevederile');
            doc.text(20, 295, Title + ", fapt pentru ");
            doc.text(20, 310, 'care ati fost sanctionat contraventional');
            doc.text(30, 325, 'La fata  locului au fost efectuate planse  fotografice care dovedesc');
            doc.text(20, 340, 'aspectele mai sus mentionate. In  termen de 3 zile aveti obligatia sa');
            doc.text(20, 355, 'va prezentati la sediul Politiei  Locale HOREZU, din Str.1  Decembrie, nr.7, Oras Horezui');
			doc.text(20, 370, 'Jud. Valcea, pentru luarea  masurilor legale.  Sanctiunea contraventionala va  fi aplicata proprietarului  autovehiculului.');
        }
		else if (ParkingName.includes("Ocna")){
			doc.setFontSize(10);
			doc.text(20, 20, 'ROMANIA');
			doc.text(20, 50, 'JUDETUL ALBA');
			doc.text(20, 80, 'PRIMARIA ORASULUI OCNA MURES');
			doc.text(20, 145, 'Telefon: 0733915595 (Politia Locala)');
			doc.text(20, 160, "Data: " + CheckDate);
			doc.text(20, 175, "Numar: " + No);
			doc.text(70, 190, 'INSTIINTARE');
			
			doc.text(20, 220, "Va informam ca autovehiculul marca " + VehicleType + ",");
			doc.text(20, 235, "culoarea " + VehicleColor + " cu numar de inmatriculare: \"" + Plate + "\",");
			doc.text(20, 250, "a fost depistat ocupand un loc de parcare cu plata din Municipiul Ocna Mures,");
			doc.text(20, 265, "situat in " + ParkingName + ", fara a avea achitat tariful de parcare,");
			doc.text(20, 280, "incalcand prevederile " + Title + " HCL nr. 11-30.01.2025,");
			doc.text(20, 295, "fapt pentru care ati fost sanctionat contraventional.");
			
			doc.text(20, 310, "La fata locului au fost efectuate fotografii care dovedesc");
			doc.text(20, 325, "aspectele mai sus mentionate.");
			
			doc.text(20, 340, "Sanctiunea contraventionala va fi aplicata proprietarului autovehiculului.");
			
		}
		else {
			doc.setFontSize(10);

			doc.text(20, 20, 'ROMANIA');
			doc.text(20, 50, 'JUDETUL CONSTANTA');
			doc.text(20, 80, 'PRIMARIA MUNICIPIULUI CONSTANTA');
			doc.text(20, 145, 'Telefon :0341 922 sau 0241 484 205');
			doc.text(20, 160, `Data     : ${CheckDate}`);
			doc.text(20, 175, `Numar  : ${No}`);

			doc.text(60, 190, 'INSTIINTARE');
			doc.text(30, 220, `Va informam ca autovehiculul marca ${VehicleType}`);
			doc.text(20, 235, `culoare ${VehicleColor} cu numar de inmatriculare: ${Plate}`);
			doc.text(20, 250, 'a fost depistat ocupand un loc de parcare cu plata din');
			doc.text(20, 265, `Municipiul Constanta, situat in zona ${ParkingName} , `);
			doc.text(20, 280, 'fara a avea achitat tariful de parcare, incalcand prevederile');
			doc.text(20, 295, `${Title} HCL 235/2018, fapt pentru `);
			doc.text(20, 310, 'care ati fost sanctionat contraventional');
			doc.text(30, 325, 'La fata locului au fost efectuate fotografii care dovedesc ');
			doc.text(20, 340, 'aspectele mai sus mentionate. Sanctiunea contraventionala');
			doc.text(20, 355, 'va fi aplicata proprietarului autovehiculului');
		}

		//doc.save(`Instiintare-${this.fine.No}`);

		this.getBase64Image(Pictures[1], (img, dimensions) => {
			doc.addImage(img, 'JPEG', 20, imageStartingRow, dimensions.width, dimensions.height);
			doc.save(`Instiintare-${this.fine.No}`);
		});
	}

	getBase64Image(imgUrl: string, callback: Function) {
		const xhr = new XMLHttpRequest();
		xhr.onload = () => {
			const reader = new FileReader();
			reader.onloadend = () => {
				const img = new Image();
				const url = reader.result.toString();


				img.onload = () => {
					const dimensions = this.calculateAspectRatio(img.width, img.height);
					callback(url.replace(/^data:image\/(png|jpeg);base64,/, ''), dimensions);
				};

				img.src = url;
			};
			reader.readAsDataURL(xhr.response);
		};

		xhr.open('GET', imgUrl);
		xhr.responseType = 'blob';
		xhr.send();
	}

	calculateAspectRatio(imgWidth: number, imgHeight: number): any {
		const maxWidth = 280;
		const maxHeight = 280;
		let ratio = 0;
		const width = imgWidth;
		const height = imgHeight;

		if (width > maxWidth) {
			ratio = maxWidth / width;
			return {
				width: maxWidth,
				height: height * ratio
			};
		} else if (height > maxHeight) {
			ratio = maxHeight / height;
			return {
				width: width * ratio,
				height: maxHeight
			};
		}
	}

	printFine() {
		const mywindow = <any>window.open('', 'PRINT', 'height=800,width=1200');
		mywindow.document.write('<html><head><title></title>');
		mywindow.document.write('</head><body >');
		mywindow.document.write('<h1>' + document.title + '</h1>');
		mywindow.document.write(
			`
            <div class="img-container">
                <img src="${this.fine.Pictures[0]}" alt="" height="300" width="auto">
                <img src="${this.fine.Pictures[1]}" alt="" height="300" width="auto">
                <img src="${this.fine.Pictures[2]}" alt="" height="300" width="auto">
                <img src="${this.fine.Pictures[3]}" alt="" height="300" width="auto">
            </div>
            <div class="print">
                <table style="width: 100%;">
                    <tr>
                        <th colspan=2>Amenda</th>
                    </tr>
                    <tr>
                        <td>Numar</td>
                        <td>${this.fine.No}</td>
                    </tr>
                    <tr>
                        <td>Contraventie</td>
                        <td>${this.fine.Title}</td>
                    </tr>
                    <tr>
                        <td>Data</td>
                        <td>${this.fine.Date}</td>
                    </tr>
                    <tr>
                        <td>Descriere</td>
                        <td>${this.fine.Description}</td>
                    </tr>
                    <tr>
                        <td>Zona</td>
                        <td>${this.fine.Parking}</td>
                    </tr>
                    <tr>
                        <td>Parcare</td>
                        <td>${this.fine.ParkingName}</td>
                    </tr>
                    <tr>
                        <td>PV</td>
                        <td>${this.fine.PvNote}</td>
                    </tr>
                    <tr>
                        <td>Nota</td>
                        <td>${this.fine.Note}</td>
                    </tr>
                    <tr>
                        <th colspan=2>Enforcer</th>
                    </tr>
                    <tr>
                        <td>Nume</td>
                        <td>${this.fine.AuthorName}</td>
                    </tr>
                    <tr>
                        <td>Telefon</td>
                        <td>${this.fine.AuthorPhone}</td>
                    </tr>
                    <tr>
                        <td>Email</td>
                        <td>${this.fine.AuthorEmail}</td>
                    </tr>
                    <tr>
                        <th colspan=2>Vehicul</th>
                    </tr>
                    <tr>
                        <td>Numar inmatriculare</td>
                        <td>${this.fine.Plate}</td>
                    </tr>
                    <tr>
                        <td>Marca</td>
                        <td>${this.fine.VehicleType}</td>
                    </tr>
                    <tr>
                        <td>Culoare</td>
                        <td>${this.fine.VehicleColor}</td>
                    </tr>
                </table>
            </div>
            <style>
                * {
                    font-family: Arial;
                }
                .print {
                    margin-top: 20px;
                }
                table {
                    border-collapse: collapse;
                    border: 1px solid black !important;
                }
                tr {
                    border: 1px solid black !important;
                    padding: 5px;
                }
                td {
                    border: 1px solid black !important;
                    padding: 5px;
                }
                .img-container {
                    text-align: center;
                }
                th {
                    text-align: left;
                    padding: 5px;
                }
            </style>
            `
		);
		mywindow.document.write('</body></html>');

		mywindow.document.close();
		mywindow.focus();

		mywindow.print();
		mywindow.close();
	}

	selectImage(url: string): void {
		this.selectedImage = url;
	}

	onPreviewClose(): void {
		this.selectImage('');
	}
}
